import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { BookingInProgressModal } from "./component";
import {
  bookingInProgressSelector,
  bookingVRInProgressSelector,
  getConfirmationDetails,
  getPollPriceQuoteCallState,
  getPollVacationRentalsPriceQuoteCallState,
  getSchedulePriceQuoteCallState,
  getScheduleVacationRentalsPriceQuoteCallState,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { CallState } from "redmond";

const mapStateToProps = (state: IStoreState) => ({
  inProgress:
    bookingInProgressSelector(state) || bookingVRInProgressSelector(state),
  priceQuoteInProgress:
    getSchedulePriceQuoteCallState(state) === CallState.InProcess ||
    getPollVacationRentalsPriceQuoteCallState(state) === CallState.InProcess ||
    getScheduleVacationRentalsPriceQuoteCallState(state) ===
      CallState.InProcess ||
    getPollPriceQuoteCallState(state) === CallState.InProcess,
  reservation: getConfirmationDetails(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type BookingInProgressModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedBookingInProgressModal = withRouter(
  connector(BookingInProgressModal)
);
